export default __webpack_public_path__ + "static/media/Keron.ef437520.jpg";